import { Spinner } from "components/shared/Spinner";
import { useTranslation } from "react-i18next";

/**
 * Card shown over the blurred analytics page while its data is being refreshed.
 * The percentage sits on the title line: the Crealo logo already moves, a second moving line below distracts.
 */
const AnalyticsRefreshProgress = ({ progress }: { progress: string }) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center gap-4">
            <Spinner size={48} />
            <p className="text-[18px] font-semibold">
                {t("Analytics.RefreshProgress.Title", { progress: Number(progress) || 0 })}
            </p>
            <p className="text-[#3d3d3d]">{t("Analytics.RefreshProgress.Description")}</p>
        </div>
    );
};

export default AnalyticsRefreshProgress;
